import axios from 'axios';
import Toastify from 'toastify-js';
import 'toastify-js/src/toastify.css';
import { initHintTest } from './hintTest';
import { openModal, closeModal } from './modal';
import { initBurst } from './confetti';

/*
==================================================
  Оптимізація завантаження GIF для емодзі
==================================================
*/
function initDynamicEmojis(container) {
  const emojiContainers = container.querySelectorAll('.test__emo');
  if (emojiContainers.length === 0) return;

  emojiContainers.forEach(emo => {
    const img = emo.querySelector('img.lazy-gif');
    if (!img) return;

    const fullSrc = img.getAttribute('data-full-src');
    if (!fullSrc) return;

    // Створюємо тимчасовий об'єкт у пам'яті для завантаження
    const tempImg = new Image();
    tempImg.src = fullSrc;

    // Коли GIF завантажився — плавно підміняємо
    tempImg.onload = () => {
      img.src = fullSrc;
      img.classList.add('is-loaded'); // Можна додати в CSS fade-in
    };
  });
}

/*
==================================================
  Точка входу
==================================================
*/
document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.test__container');
  if (!container) return;

  const type = container.dataset.type;
  const testId = container.dataset.testid;
  if (!testId) return;

  // --- HINT TEST ---
  if (type === 'hint') {
    const hintKey = 'hint_test_' + testId;

    const saved = localStorage.getItem(hintKey);
    if (saved) {
      const parsed = JSON.parse(saved);
      let inner = container.querySelector('.test__innercont');
      if (!inner) {
        inner = document.createElement('div');
        inner.classList.add('test__innercont');
        container.appendChild(inner);
      }
      inner.innerHTML = parsed.resultHTML;

      container.classList.remove('loading', 'check', 'progressing');
      initHintSavedResult(container);
      return;
    }

    const progress = sessionStorage.getItem(hintKey);
    if (progress) {
      container.classList.add('progressing');
      initHintTest(container, testId);
      return;
    }

    setupHintStart(container, testId);
    return;
  }

  // --- СТАНДАРТНА ЛОГІКА ---
  const storageKey = 'test_' + testId;

  const savedResult = localStorage.getItem(storageKey);
  if (savedResult) {
    const parsed = JSON.parse(savedResult);
    const qArr = parsed.questions?.questions || parsed.questions || [];
    finishTest(container, storageKey, qArr, parsed.id, true);
    return;
  }

  const savedData = sessionStorage.getItem(storageKey);
  if (savedData) {
    container.classList.add('progressing');
    container.classList.remove('loading', 'check');
    renderTest(container, storageKey);
    setupStandardTestListeners(container, storageKey);
    return;
  }

  container.classList.remove('loading', 'check', 'progressing');

  const startBtn = container.querySelector('.test__stbtn');
  if (startBtn) {
    startBtn.addEventListener('click', e => {
      e.preventDefault();
      startTest(container, storageKey, testId);
    });
  }

  setupStandardTestListeners(container, storageKey);
});

/*
==================================================
  HINT test старт
==================================================
*/
function setupHintStart(container, testId) {
  const startBtn = container.querySelector('.test__stbtn');
  if (!startBtn) return;

  container.classList.remove('loading', 'check');

  startBtn.addEventListener('click', e => {
    e.preventDefault();
    container.classList.add('progressing');
    const inner = container.querySelector('.test__innercont');
    if (inner) inner.innerHTML = '';
    initHintTest(container, testId);
  });
}

/*
==================================================
  Слухачі для звичайних тестів
==================================================
*/
function setupStandardTestListeners(container, storageKey) {
  container.onchange = null;

  container.addEventListener('change', async e => {
    if (!e.target.matches('input[type="radio"]')) return;

    const testType = container.dataset.type;
    const label = e.target.closest('.test__var');
    const varsContainer = e.target.closest('.test__vars');
    const sessionData = sessionStorage.getItem(storageKey);
    if (!sessionData) return;

    const data = JSON.parse(sessionData);
    const qArr = data.questions?.questions || data.questions;
    const currentIndex = qArr.findIndex(q => q.active);
    const currentQ = qArr[currentIndex];
    const selectedIdx = parseInt(e.target.value, 10);

    // 1. Записуємо вибір
    currentQ.answers.forEach((a, j) => {
      a.choosed = selectedIdx === j;
    });

    // 2. Блокуємо інпути
    container
      .querySelectorAll('input')
      .forEach(input => (input.disabled = true));

    // 3. Візуальний фідбек
    if (testType === 'var') {
      label.classList.add('selected');
    } else {
      const isCorrect =
        currentQ.answers[selectedIdx].correct ||
        currentQ.answers[selectedIdx].key === 'correct';

      if (isCorrect) {
        // Клікнули правильно
        label.classList.add('preTrue', 'true');
        if (typeof initBurst === 'function') initBurst(label);
        setTimeout(() => label.classList.remove('preTrue'), 1000);
      } else {
        // Клікнули неправильно
        label.classList.add('preFalse', 'false');

        // ШУКАЄМО ПРАВИЛЬНУ ВІДПОВІДЬ, щоб підсвітити її без анімації
        const allLabels = varsContainer.querySelectorAll('.test__var');
        currentQ.answers.forEach((ans, idx) => {
          const isThisCorrect = ans.correct || ans.key === 'correct';
          if (isThisCorrect) {
            allLabels[idx].classList.add('true'); // Додаємо тільки true (без preTrue)
          }
        });

        setTimeout(() => label.classList.remove('preFalse'), 1000);
      }
    }

    // 4. Фіналізуємо стан питання
    if (varsContainer) varsContainer.classList.add('answered');
    sessionStorage.setItem(storageKey, JSON.stringify(data));

    // 5. Автоперехід
    setTimeout(() => {
      if (currentIndex === qArr.length - 1) {
        finishTest(container, storageKey, qArr, data.id);
      } else {
        qArr[currentIndex].active = false;
        qArr[currentIndex + 1].active = true;
        sessionStorage.setItem(storageKey, JSON.stringify(data));
        renderTest(container, storageKey);
      }
    }, 2000);
  });

  // Навігація
  const navHandler = e => {
    const dataRaw = sessionStorage.getItem(storageKey);
    if (!dataRaw) return;
    const data = JSON.parse(dataRaw);
    const qArr = data.questions?.questions || data.questions;
    const currentIndex = qArr.findIndex(q => q.active);

    if (e.target.matches('.test__ctrl.left') && currentIndex > 0) {
      goToQuestion(container, storageKey, currentIndex, currentIndex - 1);
    }
    if (
      e.target.matches('.test__ctrl.right') &&
      currentIndex < qArr.length - 1
    ) {
      if (qArr[currentIndex].answers.some(a => a.choosed)) {
        goToQuestion(container, storageKey, currentIndex, currentIndex + 1);
      }
    }
  };
  container.removeEventListener('click', navHandler);
  container.addEventListener('click', navHandler);
}

function goToQuestion(container, storageKey, fromIdx, toIdx) {
  const data = JSON.parse(sessionStorage.getItem(storageKey));
  const qArr = data.questions?.questions || data.questions;
  qArr[fromIdx].active = false;
  qArr[toIdx].active = true;
  sessionStorage.setItem(storageKey, JSON.stringify(data));
  renderTest(container, storageKey);
}

/*
==================================================
  Старт звичайного тесту
==================================================
*/
async function startTest(container, storageKey, testId) {
  if (!testId) return;
  container.classList.add('loading');

  localStorage.removeItem(storageKey);
  sessionStorage.removeItem(storageKey);

  try {
    const response = await axios.post(
      '/wp-admin/admin-ajax.php',
      new URLSearchParams({ action: 'load_test', test_id: testId })
    );

    if (response.data.success && response.data.data?.questions) {
      let qArr = response.data.data.questions;
      if (qArr.length > 0) qArr[0].active = true;

      qArr = qArr.map(q => ({
        ...q,
        answers: q.answers.map(a => ({ ...a, choosed: false })),
      }));

      const storageData = { id: testId, questions: { questions: qArr } };
      sessionStorage.setItem(storageKey, JSON.stringify(storageData));

      container.classList.add('progressing');
      container.classList.remove('loading', 'check');

      renderTest(container, storageKey);
    } else {
      throw new Error('Error structure');
    }
  } catch (error) {
    container.classList.remove('loading', 'check');
    showToast(container.dataset.err1, 'error');
  }
}

/*
==================================================
  Рендер звичайного тесту
==================================================
*/
function renderTest(container, storageKey) {
  const innerCont = container.querySelector('.test__innercont');
  const sessionData = sessionStorage.getItem(storageKey);
  if (!sessionData || !innerCont) return;

  const testType = container.dataset.type;
  const data = JSON.parse(sessionData);
  const qArr = data.questions?.questions || data.questions;
  const currentIndex = qArr.findIndex(q => q.active);
  const currentQ = qArr[currentIndex];

  if (!currentQ) return;

  const total = qArr.length;
  const isAnswered = currentQ.answers.some(ans => ans.choosed);

  let contentClass =
    'questions__cont' +
    (currentQ.image ? ' widthImg' : '') +
    (currentQ.audio ? ' widthAudio' : '');

  const answersHTML = currentQ.answers
    .map((a, i) => {
      let stateClass = '';
      if (isAnswered) {
        if (testType === 'var') {
          if (a.choosed) stateClass = 'selected';
        } else {
          const isCorrect = a.correct || a.key === 'correct';
          if (a.choosed) {
            stateClass = isCorrect ? 'true' : 'false';
          } else if (isCorrect) {
            stateClass = 'true';
          }
        }
      }

      return `
      <label class="test__var ${stateClass}">
        <input type="radio" name="var" value="${i}" ${a.choosed ? 'checked' : ''} ${isAnswered ? 'disabled' : ''}/>
        <span>${a.text}</span>
      </label>`;
    })
    .join('');

  const mediaHTML = currentQ.image
    ? `<div class="test__imgquest ibg"><img src="${currentQ.image}" alt=""></div>`
    : currentQ.audio
      ? `<div class="audio__content">
            <button type="button" class="play-btn"></button>
            <audio src="${currentQ.audio}"></audio>
         </div>`
      : '';

  innerCont.innerHTML = `
    <div class="test__progress"> 
      <div class="test__question">
        <div class="test__questioninner">
          <div class="test__progresstop">${currentIndex + 1} ${container.dataset.from || 'з'} ${total} ${container.dataset.quest || 'питань'}</div>
          <h2 class="test__questtitle">${currentQ.question}</h2>
          <div class="${contentClass}">
            ${mediaHTML}
            <div class="test__vars ${isAnswered ? 'answered' : ''}">${answersHTML}</div>
          </div>
        </div>
      </div>
      <div class="test__ctrls">
        <button type="button" class="test__ctrl left" ${currentIndex === 0 ? 'disabled' : ''}></button>
        <button type="button" class="test__ctrl right" ${!isAnswered ? 'disabled' : ''}></button>
      </div>
    </div>
  `;

  container.classList.remove('loading', 'check');
  container.classList.add('noTop');

  // Ініціалізація аудіо
  setTimeout(() => {
    const audioBtn = innerCont.querySelector('.play-btn');
    const player = innerCont.querySelector('audio');

    if (audioBtn && player) {
      audioBtn.onclick = e => {
        e.preventDefault();
        e.stopPropagation();

        if (player.paused) {
          // Зупиняємо всі інші аудіо
          document.querySelectorAll('audio').forEach(a => {
            if (a !== player) {
              a.pause();
              // Клас видалиться автоматично через подію 'pause' нижче
            }
          });

          player.play().catch(err => console.error('Playback error:', err));
        } else {
          player.pause();
        }
      };

      // Коли музика починає грати — додаємо клас
      player.onplay = () => {
        audioBtn.classList.add('is-playing');
      };

      // Коли музика на паузі або закінчилася — прибираємо клас
      player.onpause = () => {
        audioBtn.classList.remove('is-playing');
      };

      player.onended = () => {
        audioBtn.classList.remove('is-playing');
      };
    }
  }, 0);
}

/*
==================================================
  Завершення тестів
==================================================
*/
async function finishTest(
  container,
  storageKey,
  questions,
  id,
  skipSave = false
) {
  const innerCont = container.querySelector('.test__innercont');
  if (!innerCont) return;

  container.classList.add('loading');

  const type = container.dataset.type || 'mark';
  let postData = { test_id: id, action: '' };

  if (type === 'mark' || type === 'prom') {
    let correct = 0;
    questions.forEach(q => {
      const chosen = q.answers.find(a => a.choosed);
      const isCorrect =
        type === 'prom' ? chosen?.key === 'correct' : chosen?.correct;
      if (isCorrect) correct++;
    });

    postData.action = type === 'mark' ? 'finish_test' : 'finish_test_prom';
    postData.correct = correct;
    postData.total = questions.length;
    postData.questions = JSON.stringify({ questions });

    if (!skipSave) {
      localStorage.setItem(
        storageKey,
        JSON.stringify({
          id,
          questions: { questions },
          result: { correct, total: questions.length },
        })
      );
      sessionStorage.removeItem(storageKey);
    }
  } else if (type === 'var') {
    const counts = {};
    questions.forEach(q => {
      const chosen = q.answers.find(a => a.choosed);
      if (chosen?.key) counts[chosen.key] = (counts[chosen.key] || 0) + 1;
    });

    let resultKey = Object.entries(counts).reduce((a, b) =>
      a[1] > b[1] ? a : b
    )[0];

    postData.action = 'finish_test_var';
    postData.result_key = resultKey;
    postData.questions = JSON.stringify({ questions });

    if (!skipSave) {
      localStorage.setItem(
        storageKey,
        JSON.stringify({
          id,
          questions: { questions },
          result: { key: resultKey, counts },
        })
      );
      sessionStorage.removeItem(storageKey);
    }
  }

  try {
    const response = await axios.post(
      '/wp-admin/admin-ajax.php',
      new URLSearchParams(postData)
    );

    if (response.data.success && response.data.data) {
      innerCont.innerHTML = response.data.data;
      initDynamicEmojis(innerCont);
      container.classList.remove('loading', 'check', 'progressing', 'noTop');
      container.classList.add('resilt');

      const openModalBtn = innerCont.querySelector(
        '.open-modal[data-id="id-results"]'
      );
      const closeBtns = innerCont.querySelectorAll('#id-results .close-modal');
      const retestBtn = innerCont.querySelector('.test__retest');

      openModalBtn?.addEventListener('click', () => openModal('id-results'));
      closeBtns.forEach(btn =>
        btn.addEventListener('click', () => {
          const modal = btn.closest('.modal');
          if (modal) closeModal(modal);
        })
      );

      retestBtn?.addEventListener('click', e => {
        e.preventDefault();
        localStorage.removeItem(storageKey);
        sessionStorage.removeItem(storageKey);
        location.reload();
      });
    }
  } catch (error) {
    container.classList.remove('loading');
    showToast(container.dataset.err2, 'error');
  }
}

/*
==================================================
  Toast & Helpers
==================================================
*/
function showToast(message, type = 'error') {
  Toastify({
    text: message,
    duration: 3000,
    close: true,
    gravity: 'top',
    position: 'right',
    style: {
      background: type === 'error' ? '#e74c3c' : '#27ae60',
      borderRadius: '.5rem',
      padding: '.7rem 1rem',
      fontSize: '.875rem',
    },
  }).showToast();
}

function initHintSavedResult(container) {
  const inner = container.querySelector('.test__innercont');
  inner.querySelectorAll('.open-modal').forEach(btn => {
    btn.addEventListener('click', () => openModal(btn.dataset.id));
  });
  inner.querySelectorAll('.close-modal').forEach(btn => {
    btn.addEventListener('click', () => {
      const m = btn.closest('.modal');
      if (m) closeModal(m);
    });
  });
  const retestBtn = inner.querySelector('.test__retest');
  retestBtn?.addEventListener('click', () => {
    const key = 'hint_test_' + container.dataset.testid;
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
    location.reload();
  });
}
